import React, { PropsWithChildren, useCallback, useMemo, useState } from 'react';

interface ContactTableContextI {
    selectedRows: string[];
    selectedAll: boolean;
    setSelectedAll?(newValue: boolean): void;
    setSelectedRows?(newSelection: string[]): void;
    clearSelectedRows?(): void;
    resetPaginationInUrl?(): void;
}
const defaultContextState = {
    selectedRows: [],
    selectedAll: false,
};

export const ContactTableContext = React.createContext<ContactTableContextI>(defaultContextState);

export const ContactTableContextProvider = ({ children }: PropsWithChildren<unknown>) => {
    const [selectedRows, setSelectedRowsState] = useState([]);
    const [selectedAll, setSelectedAllState] = useState(false);

    const setSelectedAll = useCallback((newValue) => {
        setSelectedAllState(newValue);
    }, []);

    const setSelectedRows = useCallback((newSelection) => {
        setSelectedRowsState(newSelection);
    }, []);

    const clearSelectedRows = useCallback(() => {
        setSelectedAll(false);
        setSelectedRows([]);
    }, []);

    const providerValues = useMemo(
        () => ({
            selectedRows,
            setSelectedRows,
            selectedAll,
            setSelectedAll,
            clearSelectedRows,
        }),
        [selectedRows, selectedAll]
    );

    return <ContactTableContext.Provider value={providerValues}>{children}</ContactTableContext.Provider>;
};
